import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';


const Drp_ProductGroup = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(0);
    const Group_Onchange = (Id) => {
        props.onChange(Id==null ? -1 : Id, Id==null ? "" : List.find(x => x.Id == Id).Title,Id==null ? "" : List.find(x => x.Id == Id).Type)
        setId(Id)
    }
    useImperativeHandle(ref, () => ({

        BindGroupByParentId(id, ParentId = 0) {
            
            var MyHeader = new Headers();
            MyHeader.append("ApiKey", General.APIKey());
            MyHeader.append("IsActive", 1);
            MyHeader.append("WebIsActive", -1);
            MyHeader.append("ParentId", ParentId);

            var requestOption = {
                headers: MyHeader,
                method: "Get",
                credentials: 'include'
            }
            trackPromise(
                fetch(General.ApiRoute() + "/ProductGroup/Search", requestOption)
                    .then(Response => Response.json())
                    .then(result => {
                        var lists = [];
                        for (var i = 0; i < result.length; i++) {
                            lists.push({
                                Title: result[i].title,
                                Id: result[i].id,
                                Type: result[i].type
                            })
                            if (result[i].id == id) {
                                props.onChange(id, result[i].title, result[i].type)
                            }
                        }
                        setList(lists)                      
                        setId(id);



                    })
            )


        },



    }))



    return (
        
        <rsuite.SelectPicker
            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => Group_Onchange(value)}

        />
        

    )
});

export default Drp_ProductGroup;